import { useBunja } from 'bunja/react';

import { useRouter } from '@flipster/i18n/routing';
import { Button } from '@flipster/react/design-system';
import { Modal } from '@flipster/react/design-system-legacy/modal';
import { css } from '@flipster/styled-system/css';
import { square, stack, vstack } from '@flipster/styled-system/patterns';
import segment from '@flipster/utils/segment';
import { TradingLeaderboardEvent } from '@flipster/utils/segment/events/trading-leaderboard';

import { SegmentPage } from '../../../../misc/segment/segment-page';
import { entryPopupItemBunja } from '../../bunja';
import RecurringTrophy from './img_recurring_trophy.webp';

export const LeagueRecurringCompetitionModal = () => {
  const { onClose: close, markAsRead, popup } = useBunja(entryPopupItemBunja);
  const router = useRouter();
  function onClose() {
    markAsRead('TIERED_LEAGUE_DESCRIPTION');
    close();
  }
  if (popup.id != 'RECURRING_TC_OPEN') throw new Error('Invalid popup id');
  return (
    <>
      <SegmentPage name={TradingLeaderboardEvent.TieredTcGuideBottomSheetView} />
      <Modal>
        <Modal.Close onClose={onClose} />
        <Modal.Header
          css={{
            textStyle: 'Title/M',
            color: 'content.default.level-4',
            whiteSpace: 'pre-wrap',
            tablet: { display: 'none' },
          }}
        >
          {'New! Starter competition\nEarn rewards every week'}
        </Modal.Header>
        <Modal.Content css={stack.raw({ gap: { base: 24, tablet: 16 }, tablet: { alignItems: 'center' } })}>
          <img
            src={RecurringTrophy.src}
            alt='Tap to view leagues'
            className={square({
              size: { base: 160, tablet: 120 },
              mx: 'auto',
            })}
          />
          <div className={vstack({ tabletDown: { display: 'none' } })}>
            <p className={css({ textStyle: 'Text/M/Strong', color: 'content.accent.info' })}>
              New! Starter competition
            </p>
            <p className={css({ textStyle: 'Title/M', color: 'content.default.level-4' })}>Earn rewards every week</p>
          </div>
          <p
            className={css({
              textStyle: 'Text/L/Regular',
              color: 'content.default.level-3',
              whiteSpace: 'pre-wrap',
              tablet: { textAlign: 'center' },
            })}
          >
            {'You’re automatically enrolled every week.\nTrade to rank and earn rewards.'}
          </p>
        </Modal.Content>
        <Modal.Footer>
          <Button
            hierarchy='secondary'
            color='neutral'
            size='large'
            label='Got it'
            onClick={() => {
              segment.track(TradingLeaderboardEvent.TieredTcGuideBottomSheetGotitClick);
              onClose();
            }}
          />
          <Button
            size='large'
            label='View competition'
            onClick={() => {
              segment.track(TradingLeaderboardEvent.TieredTcGuideBottomSheetTcClick);
              onClose();
              router.push(`/competitions/${popup.data.competitionUrl}`);
            }}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
};
